import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Close } from '@material-ui/icons';
import classnames from 'classnames'

import RegionAutocomplete from '../RegionAutocomplete/';
import { getText } from '../languages'
import LanguageDropdown from '../LanguageDropdown/'

import './style.scss';
import biglocalnewsLogo from '../images/biglocalnews-logo.svg';
import share from '../images/ic_share.svg';
import twitterIcon from '../images/ic_twitter.svg';
import facebookIcon from '../images/ic_facebook.svg';
import emailIcon from '../images/ic_email.svg';
import homeIcon from '../images/ic_home.svg';
import aboutIcon from '../images/ic_about.svg';

const twitterTags = encodeURIComponent(' @biglocalnews @pitchinc @GoogleNewsInit')
const emailSubject = encodeURIComponent('COVID-19 Case Mapper')

export default function Header(props) {
  const [showMenu, setShowMenu] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const { pathname } = useLocation();
  const { language, isWorld, setLanguage, directionality } = props;
  const [swapDirection, setSwapDirection] = useState({ swapping: false,  directionality });
  const isAbout = pathname.includes('about');
  const isResources = pathname.includes('resources');
  const searchRef = useRef()

  const twitterShareText = encodeURIComponent(getText(language, 'shareText'))
  const shareItems = [
    {
      label: 'twitter',
      icon: twitterIcon,
      url: (url) => `https://twitter.com/intent/tweet?text=${twitterShareText} ${url}${twitterTags}`,
    },
    {
      label: 'facebook',
      icon: facebookIcon,
      url: url => 'https://www.facebook.com/sharer.php?u=' + url,
    },
    {
      label: 'email',
      icon: emailIcon,
      url: url => `mailto:?subject=${emailSubject}&body=${twitterShareText} ${url}${twitterTags}`,
    },
  ];

  const [menuStyle, setMenuStyle] = useState({ top: 0, width: 0 });
  useEffect(() => {
    if (searchRef.current) {
      const searchPosition = searchRef.current.getBoundingClientRect();
      if (searchPosition.width !== menuStyle.width) {
        const top = searchPosition.top + searchPosition.height;
        setMenuStyle({ top, width: searchPosition.width });
      }
    }
  }, [menuStyle, searchRef]);

  useEffect(() => {
    setShowMenu(false);
  }, [pathname, language]);

  useEffect(() => {
    if (directionality !== swapDirection.directionality) {
      setSwapDirection({ swapping: true, directionality });
    } else if (swapDirection.swapping) {
      setSwapDirection({ swapping: false, directionality });
    }
  }, [swapDirection, directionality]);

  const shareMenu = (
    <div className={`shareMenu ${swapDirection.swapping ? 'swap' : ''} ${showShare ? 'open' : ''}`}>
      <div className='content'>
        <div className='title'>
          {getText(language, 'share')}
        </div>
        <ul>
          {
            shareItems.map(item => (
              <a
                key={item.label}
                href={`${item.url(encodeURIComponent(document.location))}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                <li>
                  <div className='icon'>
                    <img src={item.icon} alt='' />
                  </div>
                  <div className='label'>
                    {getText(language, item.label)}
                  </div>
                </li>
              </a>
            ))
          }
        </ul>
      </div>
    </div>
  );

  return (
      <header>
        <div className={classnames('Header', props.className, directionality)}>
          <div className='section title'>
            <div className='headerRow'>
              <div className='menuIcon' onClick={() => setShowMenu(!showMenu)}>
                <Close className={`icon close ${showMenu ? null : 'hidden'}`} />
                <Menu className={`icon ${showMenu ? 'hidden' : null}`} />
              </div>
              <div className='menuLogo'>
                <a href="https://biglocalnews.org/" target='_blank' rel='noopener noreferrer'><img src={biglocalnewsLogo} alt='Big Local News' /></a>
              </div>
              <div className='titles'>
                <div className='mainTitle'>
                  {getText(language, isWorld ? 'covid19CaseMapperWorld' : 'covid19CaseMapperUS')}
                </div>
                <div className='subtitle'>
                  {getText(language, isWorld ? 'findCovid19DataWorld' : 'findCovid19DataUs')}
                  {' '}
                  <span style={{ whiteSpace: 'nowrap', textTransform: 'capitalize' }}>
                    {getText(language, 'updated')}: {props.dateUpdated}
                  </span>
                </div>
              </div>
              <div className='share' onClick={() => setShowShare(!showShare)}>
                <img src={share} alt='share' />
                {shareMenu}
              </div>
            </div>
          </div>
          <div className='section search' ref={searchRef}>
            <div className='autocomplete'>
              <RegionAutocomplete {...props} />
            </div>
          </div>
          <div className={`section menu ${showMenu ? 'open' : ''}`}
          // style={menuStyle}
          style={{ top: menuStyle.top }}
          >
            <div className='menu'>
              <div className={`menuItem ${!isAbout && !isResources ? 'selected' : ''}`}>
                <div className='menuBlock'>
                  <Link to='/' onClick={props.closeCounty}>
                    {
                      isWorld
                        ? <img src={homeIcon} alt={getText(language, 'home')} />
                        : getText(language, 'home')
                    }
                  </Link>
                </div>
              </div>
              <div className={`menuItem ${isAbout ? 'selected' : ''}`}>
                <div className='menuBlock'>
                  <Link to='/about'>
                    {
                      isWorld
                        ? <img src={aboutIcon} alt={getText(language, 'about')} />
                        : getText(language, 'about')
                    }
                  </Link>
                </div>
              </div>
              {
                isWorld ? null : (
                  <div className={`menuItem ${isResources ? 'selected' : ''}`}>
                    <div className='menuBlock'>
                      <Link to='/resources'>
                        {getText(language, 'resources')}
                      </Link>
                    </div>
                  </div>
                )
              }
              {
                isWorld ? (
                  <div className='menuItem'>
                    <div className='menuBlock'>
                      <div className='languageDropdown'>
                        <LanguageDropdown language={language} setLanguage={setLanguage} />
                      </div>
                    </div>
                  </div>
                ) : null
              }
              <div className='menuItem share' onClick={() => setShowShare(!showShare)}>
                <div className='menuBlock'>
                  <img src={share} alt='share' />
                </div>
                {shareMenu}
              </div>
            </div>
          </div>
        </div>
      </header>
  );
}